export const mixpanelIgnoreEvents = ['inner page view'];
